//@flow
export const CREATE_REQUESTED = "sections/CREATE_REQUESTED";
export const CREATE_COMPLETED = "sections/CREATE_COMPLETED";
export const CREATE_FAILED = "sections/CREATE_FAILED";

export const UPDATE_REQUESTED = "sections/UPDATE_REQUESTED";
export const UPDATE_COMPLETED = "sections/UPDATE_COMPLETED";
export const UPDATE_FAILED = "sections/UPDATE_FAILED";

export const MOVE_REQUESTED = "sections/MOVE_REQUESTED";
export const MOVE_COMPLETED = "sections/MOVE_COMPLETED";
export const MOVE_FAILED = "sections/MOVE_FAILED";

export const DELETE_REQUESTED = "sections/DELETE_REQUESTED";
export const DELETE_COMPLETED = "sections/DELETE_COMPLETED";
export const DELETE_FAILED = "sections/DELETE_FAILED";

export const FETCH_LIST_REQUESTED = "sections/FETCH_LIST_REQUESTED";
export const FETCH_LIST_COMPLETED = "sections/FETCH_LIST_COMPLETED";
export const FETCH_LIST_FAILED = "sections/FETCH_LIST_FAILED";

export const FETCH_DETAILS_REQUESTED = "sections/FETCH_DETAILS_REQUESTED";
export const FETCH_DETAILS_COMPLETED = "sections/FETCH_DETAILS_COMPLETED";
export const FETCH_DETAILS_FAILED = "sections/FETCH_DETAILS_FAILED";

export const RESET_LIST = "sections/RESET_LIST";
